import * as React from 'react';
import { useMemo } from 'react';
import { Accordion } from 'semantic-ui-react';

import { AlphaDataTable } from '../../AlphaDataTable/AlphaDataTable';

import { SummaryDataTableInt } from './types';

const SummaryDataTable = (props: SummaryDataTableInt) => {
  const { summaryTable, summaryTableOSPROD, typeStage, isTestPeriodControlShown, isTestPeriodShown } = props;
  const summaryIs = summaryTable ? summaryTable.get('is') : null;
  const summaryOSPROD = typeStage === 'os' || typeStage === 'prod' ? (summaryTableOSPROD ? summaryTableOSPROD.get(typeStage) : null) : null;

  const ISRowRecords = useMemo(() => {
    if (!summaryIs) {
      return null;
    }

    if (typeStage === 'is') {
      return summaryIs.get('data').toJS();
    }

    if (!isTestPeriodShown && typeStage === 'train') {
      return summaryIs
        .get('data')
        .toJS()
        .filter((row: string) => row[row.length - 1] === typeStage.toUpperCase());
    }

    return summaryIs.get('data').toJS();
  }, [summaryIs, typeStage, isTestPeriodShown]);
  if (isTestPeriodControlShown) {
    return (
      <Accordion.Content>
        <AlphaDataTable
          modifiers={['simulation', 'is']}
          typeStage={'is'}
          tableRowsRecords={ISRowRecords}
          tableRowsProperties={summaryIs && summaryIs.get('header').toJS()}
          stagePerformanceColumnsTypes={summaryIs && summaryIs.get('types').toJS()}
          dataType={summaryIs && summaryIs.get('dataType').toJS()}
        />
      </Accordion.Content>
    );
  }
  return (
    <Accordion.Content>
      {summaryOSPROD ? (
        <AlphaDataTable
          modifiers={['simulation', typeStage]}
          typeStage={typeStage}
          tableRowsRecords={summaryOSPROD && summaryOSPROD.get('data').toJS()}
          tableRowsProperties={summaryOSPROD && summaryOSPROD.get('header').toJS()}
          stagePerformanceColumnsTypes={summaryOSPROD && summaryOSPROD.get('types').toJS()}
          dataType={summaryOSPROD && summaryOSPROD.get('dataType').toJS()}
        />
      ) : null}
      <AlphaDataTable
        modifiers={['simulation', 'is']}
        typeStage={'is'}
        tableRowsRecords={summaryIs && summaryIs.get('data').toJS()}
        tableRowsProperties={summaryIs && summaryIs.get('header').toJS()}
        stagePerformanceColumnsTypes={summaryIs && summaryIs.get('types').toJS()}
        dataType={summaryIs && summaryIs.get('dataType').toJS()}
      />
    </Accordion.Content>
  );
};

export default SummaryDataTable;
